import moment from "moment";
import inboxService from "venuescanner-js/react/components/Inbox/services/inboxService";
import { uploadToApi } from "venuescanner-js/services/api";
import { isHost } from "venuescanner-js/constants/user_type";

export function submitUpdatedEventDetails({ thread }, eventDetails) {
  if (isHost(thread)) {
    return inboxService.updateThread({
      ...eventDetails,
      payment: thread.depositAmountValue,
    });
  }

  return inboxService.updateThread({
    ...eventDetails,
    schedule: null,
    payment: null,
  });
}

export async function submitQuote({ thread, venue }, quote) {
  const uploadedAttachments = await uploadAttachments(
    venue._id,
    quote.attachments
  );

  // This is not the way I want to do this, but it's the fastest way now.
  // I'd like to only updateThread when the quote has already been received,
  // Reopen when the thread is cancelled (not expired), etc.
  const method = thread.can.ACCEPT
    ? "acceptThread"
    : thread.can.REOPEN
    ? "reopenThread"
    : "updateThread";

  return inboxService[method]({
    ...quote,
    attachments: uploadedAttachments,
  });
}

export function reopenEnquiry(enquiry) {
  return inboxService.reopenThread({
    ...enquiry,
    schedule: null,
    payment: null,
  });
}

export function nudgeHost(quoteRequest) {
  return inboxService.nudgeHost(quoteRequest);
}

export function unmarkEnquiryAsBooked(threadId) {
  return inboxService.unmarkBookedThread({
    _id: threadId,
  });
}

export function markEnquiryAsBooked(threadId) {
  return inboxService.markBookedThread({
    _id: threadId,
    message: "",
    attachments: [],
  });
}

// For cancelling an expired thread
// We haven't moved the EnquiryDecline logic to here.
export function cancelThread(thread) {
  return inboxService.cancelThread({
    _id: thread._id,
    message: "",
    offer: thread.cumulativeOffer,
  });
}

export function bookThread(threadId) {
  return inboxService.bookThread({
    _id: threadId,
    message: "",
    attachments: [],
  });
}

export function updateBookingPrice(thread, price) {
  const offer = {
    inquire_id: thread.cumulativeOffer.inquire_id,
    cost: price,
    capacity: thread.cumulativeOffer.capacity,
    dates: `${moment(new Date(thread.localDates.from)).format(
      "D/M/YYYY"
    )} - ${moment(new Date(thread.localDates.to)).format("D/M/YYYY")}`,
    hours: `${moment(thread.localDates.from).format("HH:mm")} - ${moment(
      thread.localDates.to
    ).format("HH:mm")}`,
  };

  return inboxService.updateThread({
    _id: thread._id,
    offer,
    message: "",
    attachments: [],
  });
}

function uploadAttachments(venueId, attachments) {
  if (!venueId) return [];

  const url = `attachment/upload/${venueId}`;

  const upload = async (file) => {
    const res = await uploadToApi(url, file);
    if (res.data && res.data.data instanceof Array) {
      const img = res.data.data[0];
      return img;
    }
  };

  return Promise.all(attachments.map((file) => upload(file)));
}
